import { useRef } from 'react';

import { fontStyles } from '@/styles/typography';

import { Accordion } from '../../Accordion';
import { TextSkeleton } from '../../Skeleton';

interface Props {
  data: { id: number; question: string; answer: string }[];
  isLoading: boolean;
}

function LoadingFAQItem({ value }: { value: string }) {
  return (
    <Accordion.Item value={value}>
      <Accordion.Trigger>
        <TextSkeleton width={200} height={16} className="pb-2" />
      </Accordion.Trigger>
      <Accordion.Content>
        <TextSkeleton lines={3} height={12} className="pb-2" />
      </Accordion.Content>
    </Accordion.Item>
  );
}

export function TokenProfileFAQ({ data, isLoading }: Props) {
  const rootRef = useRef<HTMLDivElement>(null);

  return (
    <div className="flex flex-col px-6 tablet:px-8 pt-6 pb-6 tablet:pb-8">
      <h2 className={fontStyles({ variant: 'H5', class: ['mb-6', 'block'] })}>FAQ</h2>
      <Accordion.Root ref={rootRef} type="multiple" className="w-full">
        {isLoading
          ? ['loading-1', 'loading-2', 'loading-3'].map((value) => (
              <LoadingFAQItem key={value} value={value} />
            ))
          : data
              .sort((a, b) => a.id - b.id)
              .map(({ question, answer }) => {
                return (
                  <Accordion.Item key={question} value={question}>
                    <Accordion.Trigger>{question}</Accordion.Trigger>
                    <Accordion.Content>
                      <div dangerouslySetInnerHTML={{ __html: answer }} />
                    </Accordion.Content>
                  </Accordion.Item>
                );
              })}
      </Accordion.Root>
    </div>
  );
}
